<div class="timeline-badge">
  <a><em class="fa fa-circle"></em></a>
</div>
<h4 *ngIf="timelineActive">
  {{ timeline.dataHora | date: 'HH:mm' }}
  <small>{{ timeline.dataHora | date: 'dd/MM/yyyy' }}</small>
</h4>
<div
  class="timeline-panel"
  [ngClass]="{ 'timeline-panel-disabled-green': !timelineActive }"
>
  <div class="step">
    <span class="icon wait"></span>
    <h2>{{ timeline.tituloStatus }}</h2>
    <span>{{ timeline.subTituloStatus }}</span>
    <div *ngIf="timelineActive" class="specifications">
      <div *ngIf="isCardDireito()" class="col-xs-12 marginT10">
        <div *ngFor="let item of timeline.cardDireito">
          <div
            *ngIf="
              item.tipo === 'TEXTO' ||
              item.tipo === 'TEXTO_ALTERACAO' ||
              item.tipo === 'TEXTO_SIM' ||
              item.tipo === 'TEXTO_NAO'
            "
            class="col-xs-12"
          >
            {{ item.valor }}
          </div>
        </div>
        <span *ngIf="!idEnviando"
          ><i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Enviando...</span
        >
        <div *ngFor="let item of timeline.cardDireito">
          <div *ngIf="item.tipo === 'BOTÃO'" class="col-xs-12">
            <button
              *ngIf="
                item.valor === 'NÃO' || item.valor === 'Desistiu do Veículo'
              "
              class="btn btn-border-orange marginT10"
              (click)="prosseguirNegocio(item.acoes[0].acao)"
            >
              {{ item.valor }}
            </button>
            <button
              [disabled]="proposta.possuiSosInversoEmAberto == 'S'"
              *ngIf="
                item.valor === 'SIM' ||
                item.valor === 'Fechou com Outra Financeira'
              "
              class="btn btn-full-orange marginT10"
              (click)="prosseguirNegocio(item.acoes[0].acao)"
            >
              {{ item.valor }}
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!timelineActive || !isCardDireito()"><br /></div>
    </div>
  </div>
  <app-modal-message
    #modalMessage
    [title]="'common modal'"
    [message]="'Mensagem'"
    [hideClose]="false"
    (ok)="ok()"
    (close)="close()"
  ></app-modal-message>
</div>
